﻿/* eslint-disable */
import '../sass/style.scss';

import { ComponentsBinder } from '@basic-orange/componentsbinder';
import Router from './router.js';

import verge from 'verge';
import $ from 'jquery';
import 'jquery.scrollto';
import './vendor/foundation-sites/npm.js';
import './vendor/socialsharekit/socialShares.js';
import 'jquery.scrollto';
//only enable when needed
import 'picturefill';
import 'slick-carousel';
import 'magnific-popup';
import 'tipr';

import componentIncludes from '../../build/dist/webpack-includes.js';
import modulesIncludes from '../../build/dist/webpack-includes-modules.js';
var componentsJson = require('../../build/dist/components.json');
var modulesJson = require('../../build/dist/modules.json');

//window.$ = $;
//window.jQuery = $;
var jQuery = $;

jQuery.extend(verge);

$(function () {
    global.$document = $(document);
    global.$window = $(window);
    global.globalData = $('body').data();

    global.debug = globalData.islocal !== null && globalData.islocal === true;

    //init foundation
    global.$document.foundation();
    SocialShareKit.init();
    window.GoogleMapsApiLoaded = false;
    window.onGoogleMapsApiLoaded = function () {
        window.GoogleMapsApiLoaded = true;
    };

    var componentsBinder = new ComponentsBinder(componentIncludes, componentsJson.components);
    componentsBinder.bindComponentsToDom();

    //init modules
    var router = new Router(modulesIncludes, modulesJson.modules);

    router
        .registerSingleton('MainMenu')
        .registerSingleton('DrilldownMenu')
        .registerSingleton('StickyHeader')
        .registerSingleton('OpenYoutubeModal')
        .registerSingleton('OpenPersonModal')
        .registerSingleton('ToolTip')
        .registerSingleton('SearchBox')
        .registerTransient('OrangeCookie')
        .registerTransient('Accordion')
        .registerTransient('SearchResults')
        .registerTransient('Filter')
        .registerTransient('LetterIndexScroller')
        .registerTransient('Timeline')
        .registerTransient('Rte')
        .registerTransient('InfoNumber')
        .registerTransient('VacancySticky')
        .registerTransient('ResponsivePlaceholder')
        .registerTransient('Slider')
        .registerTransient('Disclaimer')

        .dom('.header', 'MainMenu')
        .dom('.drilldownMenu', 'DrilldownMenu')
        .dom('.header', 'StickyHeader')
        .dom('.open-youtube-popup', 'OpenYoutubeModal')
        .dom('.open-person-popup', 'OpenPersonModal')
        .dom('.tooltip', 'ToolTip')
        .dom('.searchBox', 'SearchBox')
        .dom('.OrangeCookie', 'OrangeCookie')
        .dom('.accordion', 'Accordion')
        .dom('.searchResults', 'SearchResults')
        .dom('.filter', 'Filter')
        .dom('.letterIndex', 'LetterIndexScroller')
        .dom('.rte', 'Rte')
        .dom('.infoNumber', 'InfoNumber')
        .dom('.timeline', 'Timeline')
        .dom('.responsivePlaceholder', 'ResponsivePlaceholder')
        .dom('.umb-tpl-Vacancy-contentSticky', 'VacancySticky')
        .dom('.logo-slider', 'Slider')
        .dom('.disclaimer', 'Disclaimer');
});

$(window).on('load', function () {
    $('html').fadeIn(200);
});
